import css from "@styled-system/css";
import styled from "styled-components";

export const Details = styled.div`
  text-align: center;
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
  max-width: 150px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Link = styled.a`
  text-decoration: none;

  ${css({
    color: "foreground.link",
    fontWeight: "bold",
  })}
`;
